export default __webpack_public_path__ + "static/media/bedecarratz_julio.aa55efc0.jpg";